/*
 * Detect if page lives in an iframe
 * also loads iframe resizing script
 */

import { loadScript } from './utils';
import { Logger } from './logger';

const CHECK_INTERVAL = 50;
const CHECK_DURATION = 1000;

class IframeDetect {
  constructor() {
    this.started = false;
    this.inFrame = null;
    this.resizerLoaded = false;
    this.resizerRunning = false;
    this.log = new Logger('tsg_iframedetect');
  }

  start(elem) {
    if (!this.started) {
      this.elem = elem;
      this.inFrame = window.self !== window.parent || window.TSG_IFRAME;
      this.elem.classList.toggle('tsg-iframe', this.inFrame);
      this.elem.classList.toggle('tsg-no-iframe', !this.inFrame);
      this.started = true;
      this.log.debug(this.inFrame ? 'Living in an iframe :(' : 'Not living in an iframe :)');
      if (this.inFrame) this.loadResizer();
    }
  }

  loadResizer() {
    window.iFrameResizer = {
      onReady: () => {
        this.resizerRunning = true;
        this.log.debug('iframe resizer running');
      },
    };
    loadScript(`${PATH}vendor/iframeResizer.contentWindow.min.js`).then(() => {
      this.log.debug('loaded iframe resizer content window script');
      this.resizerLoaded = true;
    });
  }

  // This method is important: it allows to check from the side of the graphics
  // whether they run in an environment with a fixed height (iframe, resizing
  // not working)
  checkFixedHeight() {
    // if we are not in an iframe everything is fine
    if (!this.inFrame) return Promise.resolve(false);
    // otherwise we need to check if the resizing works
    // if we know this already we can resolve immediately
    if (this.resizerRunning) return Promise.resolve(false);

    // or already checked
    if (this.fixedHeight) return Promise.resolve(true);
    // otherwise we might need to wait a bit...
    let t = 0;
    return new Promise((resolve) => {
      const inter = setInterval(() => {
        t += CHECK_INTERVAL;
        if (t > CHECK_DURATION) {
          clearInterval(inter);
          this.checkHeight();
          this.fixedHeight = true;
          return resolve(true);
        }
        if (this.resizerRunning) {
          clearInterval(inter);
          return resolve(false);
        }
        return null;
      }, CHECK_INTERVAL);
    });
  }

  checkHeight() {
    this.height = window.innerHeight - 150;
    this.log.debug(`found fixed height: ${this.height}`);
    window.addEventListener('resize', () => {
      this.height = window.innerHeight - 150;
    });
  }
}

export default new IframeDetect();
